import clr from "color";

export const alpha = (color, opacity) => clr(color).alpha(opacity).string();

export const darken = (color, percentage) =>
  clr(color).darken(percentage).string();

export const lighten = (color, percentage) =>
  clr(color).lighten(percentage).string();
